module.exports = __webpack_public_path__ + "static/stats@2x-31a8ccc8eb9971a69e18c894b0007a73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/deliveroo/stats@2x.jpg
// module id = 362
// module chunks = 3627797113349 20562973939449 33019919093843